{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "下載",
      "UPLOADING": "上傳中"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "送出"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "重新發送訊息",
      "ERROR_MESSAGE": "無法傳送！請重新嘗試。"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "不可用"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "我們在線上",
    "OFFLINE": "我們目前不在線上",
    "BACK_AS_SOON_AS_POSSIBLE": "我們會盡快回來"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "通常在幾分鐘內回覆",
    "IN_A_FEW_HOURS": "通常在幾小時內回覆",
    "IN_A_DAY": "通常在一天內回覆",
    "BACK_IN_HOURS": "我們將在 {n} 小時後恢復在線 | 我們將在 {n} 小時後恢復在線",
    "BACK_IN_MINUTES": "我們將在 {time} 分鐘後恢復在線",
    "BACK_AT_TIME": "我們將在 {time} 恢復在線",
    "BACK_ON_DAY": "我們將在 {day} 恢復在線",
    "BACK_TOMORROW": "我們將於明天恢復在線",
    "BACK_IN_SOME_TIME": "我們將在一段時間後恢復在線"
  },
  "DAY_NAMES": {
    "SUNDAY": "星期日",
    "MONDAY": "星期一",
    "TUESDAY": "週二",
    "WEDNESDAY": "週三",
    "THURSDAY": "週四",
    "FRIDAY": "週五",
    "SATURDAY": "週六"
  },
  "START_CONVERSATION": "開始對話",
  "END_CONVERSATION": "結束對話",
  "CONTINUE_CONVERSATION": "繼續對話",
  "YOU": "您",
  "START_NEW_CONVERSATION": "開始一個新對話",
  "VIEW_UNREAD_MESSAGES": "您有未讀訊息",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "查看新訊息",
    "CLOSE_MESSAGES_BUTTON": "關閉",
    "COMPANY_FROM": "發自",
    "BOT": "機器人"
  },
  "BUBBLE": {
    "LABEL": "與我們對話"
  },
  "POWERED_BY": "由 Chatwoot 支援",
  "EMAIL_PLACEHOLDER": "請輸入您的電子信箱",
  "CHAT_PLACEHOLDER": "輸入你的訊息",
  "TODAY": "今天",
  "YESTERDAY": "昨天",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "聯絡人姓名",
        "PLACEHOLDER": "請輸入您的完整姓名",
        "REQUIRED_ERROR": "姓名為必填"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "電子信箱地址",
        "PLACEHOLDER": "請輸入你的 Email",
        "REQUIRED_ERROR": "電子郵件為必填",
        "VALID_ERROR": "請輸入一個有效的電子信箱"
      },
      "PHONE_NUMBER": {
        "LABEL": "聯絡人電話",
        "PLACEHOLDER": "請輸入您的電話號碼",
        "REQUIRED_ERROR": "電話號碼為必填",
        "DIAL_CODE_VALID_ERROR": "請選擇國家程式碼",
        "VALID_ERROR": "請輸入一個有效的電話號碼",
        "DROPDOWN_EMPTY": "沒有檢索到相關資訊",
        "DROPDOWN_SEARCH": "搜尋國家/地區"
      },
      "MESSAGE": {
        "LABEL": "訊息",
        "PLACEHOLDER": "請輸入你的訊息",
        "ERROR": "訊息過短"
      }
    },
    "CAMPAIGN_HEADER": "在開始對話之前請提供您的名字及電郵",
    "IS_REQUIRED": "必填",
    "REQUIRED": "必填項",
    "REGEX_ERROR": "請輸入有效的字符"
  },
  "FILE_SIZE_LIMIT": "{MAXIMUM_FILE_UPLOAD_SIZE} 已超出檔案大小限制",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "無效的欄位"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "搜尋 emojis",
    "NOT_FOUND": "查無相符的 emoji",
    "ARIA_LABEL": "表情選擇"
  },
  "CSAT": {
    "TITLE": "為此對話評分",
    "SUBMITTED_TITLE": "感謝您提交的評分",
    "PLACEHOLDER": "告訴我們更多..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "請求對話記錄",
    "SEND_EMAIL_SUCCESS": "對話記錄已成功發送",
    "SEND_EMAIL_ERROR": "出現錯誤，請重試"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "點擊這裡加入",
      "LEAVE_THE_ROOM": "留下電話"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "熱門文章",
    "VIEW_ALL_ARTICLES": "查看所有文章",
    "IFRAME_LOAD_ERROR": "載入文章時出錯，請重新整理頁面並重試。"
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "圖片訊息"
    },
    "audio": {
      "CONTENT": "聲音訊息"
    },
    "video": {
      "CONTENT": "影片訊息"
    },
    "file": {
      "CONTENT": "附件"
    },
    "location": {
      "CONTENT": "位置"
    },
    "fallback": {
      "CONTENT": "分享了一個網址"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "回覆:"
  }
}
